
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crm-pipeline",
      function () {
        return require("private-next-pages/crm-pipeline/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crm-pipeline"])
      });
    }
  